export const PRODUCTION_SERVICES_IDS = {
    HEART_FAILURE_INITIAL_ENGLISH: '673563',
    HEART_FAILURE_INITIAL_SPANISH: '673565',
    HEART_FAILURE_FOLLOWUP_ENGLISH: '673566',
    HEART_FAILURE_FOLLOWUP_SPANISH: '673567',
    DIABETES_INITIAL_ENGLISH: '673291',
    DIABETES_INITIAL_SPANISH: '673538',
    DIABETES_FOLLOWUP_ENGLISH: '673539',
    DIABETES_FOLLOWUP_SPANISH: '673540',
    DIABETES_DEVICEFLEX_INITIAL_ENGLISH: '673555',
    DIABETES_DEVICEFLEX_INITIAL_SPANISH: '673556',
    DIABETES_DEVICEFLEX_FOLLOWUP_ENGLISH: '673557',
    DIABETES_DEVICEFLEX_FOLLOWUP_SPANISH: '673558',
    PREDIABETES_INITIAL_ENGLISH: '673559',
    PREDIABETES_INITIAL_SPANISH: '673560',
    PREDIABETES_FOLLOWUP_ENGLISH: '673561',
    PREDIABETES_FOLLOWUP_SPANISH: '673562',
    HYPERTENSION_INITIAL_ENGLISH: '673568',
    HYPERTENSION_INITIAL_SPANISH: '673569',
    HYPERTENSION_FOLLOWUP_ENGLISH: '673570',
    HYPERTENSION_FOLLOWUP_SPANISH: '673572',
    WEIGHT_MANAGEMENT_INITIAL_ENGLISH: '673574',
    WEIGHT_MANAGEMENT_INITIAL_SPANISH: '673575',
    WEIGHT_MANAGEMENT_FOLLOWUP_ENGLISH: '673576',
    WEIGHT_MANAGEMENT_FOLLOWUP_SPANISH: '673577',
    ADV_WEIGHT_MANAGEMENT_INITIAL_ENGLISH: '715328',
    ADV_WEIGHT_MANAGEMENT_INITIAL_SPANISH: '715329',
    ADV_WEIGHT_MANAGEMENT_FOLLOWUP_ENGLISH: '715330',
    ADV_WEIGHT_MANAGEMENT_FOLLOWUP_SPANISH: '715331',
    ADV_PREDIABETES_INITIAL_ENGLISH: '738529',
    ADV_PREDIABETES_INITIAL_SPANISH: '738530',
    ADV_PREDIABETES_FOLLOWUP_ENGLISH: '738531',
    ADV_PREDIABETES_FOLLOWUP_SPANISH: '738532',
    COMPR_WEIGHT_CARE_INITIAL_ENGLISH: '715333',
    COMPR_WEIGHT_CARE_INITIAL_SPANISH: '715334',
    COMPR_WEIGHT_CARE_FOLLOWUP_ENGLISH: '715335',
    COMPR_WEIGHT_CARE_FOLLOWUP_SPANISH: '715336',
    COMPR_PREDIABETES_CARE_INITIAL_ENGLISH: '738533',
    COMPR_PREDIABETES_CARE_INITIAL_SPANISH: '738534',
    COMPR_PREDIABETES_CARE_FOLLOWUP_ENGLISH: '738535',
    COMPR_PREDIABETES_CARE_FOLLOWUP_SPANISH: '738536',
    ADOLESCENT_WEIGHT_MANAGEMENT_INITIAL_ENGLISH: '716519',
    ADOLESCENT_WEIGHT_MANAGEMENT_INITIAL_SPANISH: '716520',
    ADOLESCENT_WEIGHT_MANAGEMENT_FOLLOWUP_ENGLISH: '716521',
    ADOLESCENT_WEIGHT_MANAGEMENT_FOLLOWUP_SPANISH: '716522',
};
export const TESTING_SERVICES_IDS = {
    HEART_FAILURE_INITIAL_ENGLISH: '688855',
    HEART_FAILURE_INITIAL_SPANISH: '688856',
    HEART_FAILURE_FOLLOWUP_ENGLISH: '688857',
    HEART_FAILURE_FOLLOWUP_SPANISH: '688858',
    DIABETES_INITIAL_ENGLISH: '688843',
    DIABETES_INITIAL_SPANISH: '688844',
    DIABETES_FOLLOWUP_ENGLISH: '688845',
    DIABETES_FOLLOWUP_SPANISH: '688846',
    DIABETES_DEVICEFLEX_INITIAL_ENGLISH: '688847',
    DIABETES_DEVICEFLEX_INITIAL_SPANISH: '688848',
    DIABETES_DEVICEFLEX_FOLLOWUP_ENGLISH: '688849',
    DIABETES_DEVICEFLEX_FOLLOWUP_SPANISH: '688850',
    PREDIABETES_INITIAL_ENGLISH: '688851',
    PREDIABETES_INITIAL_SPANISH: '688852',
    PREDIABETES_FOLLOWUP_ENGLISH: '688853',
    PREDIABETES_FOLLOWUP_SPANISH: '688854',
    HYPERTENSION_INITIAL_ENGLISH: '688859',
    HYPERTENSION_INITIAL_SPANISH: '688860',
    HYPERTENSION_FOLLOWUP_ENGLISH: '688861',
    HYPERTENSION_FOLLOWUP_SPANISH: '688862',
    WEIGHT_MANAGEMENT_INITIAL_ENGLISH: '688863',
    WEIGHT_MANAGEMENT_INITIAL_SPANISH: '688864',
    WEIGHT_MANAGEMENT_FOLLOWUP_ENGLISH: '688865',
    WEIGHT_MANAGEMENT_FOLLOWUP_SPANISH: '688866',
    ADV_WEIGHT_MANAGEMENT_INITIAL_ENGLISH: '713617',
    ADV_WEIGHT_MANAGEMENT_INITIAL_SPANISH: '713619',
    ADV_WEIGHT_MANAGEMENT_FOLLOWUP_ENGLISH: '713622',
    ADV_WEIGHT_MANAGEMENT_FOLLOWUP_SPANISH: '713624',
    ADV_PREDIABETES_INITIAL_ENGLISH: '738517',
    ADV_PREDIABETES_INITIAL_SPANISH: '738518',
    ADV_PREDIABETES_FOLLOWUP_ENGLISH: '738519',
    ADV_PREDIABETES_FOLLOWUP_SPANISH: '738521',
    COMPR_WEIGHT_CARE_INITIAL_ENGLISH: '715069',
    COMPR_WEIGHT_CARE_INITIAL_SPANISH: '715070',
    COMPR_WEIGHT_CARE_FOLLOWUP_ENGLISH: '715066',
    COMPR_WEIGHT_CARE_FOLLOWUP_SPANISH: '715067',
    COMPR_PREDIABETES_CARE_INITIAL_ENGLISH: '738522',
    COMPR_PREDIABETES_CARE_INITIAL_SPANISH: '738523',
    COMPR_PREDIABETES_CARE_FOLLOWUP_ENGLISH: '738524',
    COMPR_PREDIABETES_CARE_FOLLOWUP_SPANISH: '738525',
    ADOLESCENT_WEIGHT_MANAGEMENT_INITIAL_ENGLISH: '716229',
    ADOLESCENT_WEIGHT_MANAGEMENT_INITIAL_SPANISH: '716230',
    ADOLESCENT_WEIGHT_MANAGEMENT_FOLLOWUP_ENGLISH: '716231',
    ADOLESCENT_WEIGHT_MANAGEMENT_FOLLOWUP_SPANISH: '716232',
};
// Found in https://github.com/Teladoc/telapp/blob/axle_integration_supernova/dependencies/availability_gateway_engine/config/axle_services_reason_codes.yml
export const AXLE_SERVICES_IDS = {
    HEART_FAILURE: '132462',
    DIABETES: '132459',
    DIABETES_DEVICEFLEX: '132460',
    PREDIABETES: '132461',
    HYPERTENSION: '132463',
    WEIGHT_MANAGEMENT: '132465',
    ADV_WEIGHT_MANAGEMENT: '132457',
    ADV_PREDIABETES: '132469',
    COMPR_WEIGHT_CARE: '132458',
    COMPR_PREDIABETES_CARE: '132468',
    ADOLESCENT_WEIGHT_MANAGEMENT: '132456',
};
export const BASIC_AUTH = 'bWVtYmVyUG9ydGFsOjhBM1RHTV5ANlA=';
export const BASIC_AUTH_MOBILE = 'bW9iaWxlSW9zVjE6ODNXN0RBSEI2NQ==';
export const ANY_COACH = 'Any Coach';
export const DIFFERENT_COACH = 'Different Coach';
export const WM_PROGRAM = 'WEIGHT_MANAGEMENT';
export const AWM_PROGRAM = 'ADV_WEIGHT_MANAGEMENT';
export const ADPP_PROGRAM = 'ADV_PREDIABETES';
export const CWC_PROGRAM = 'COMPR_WEIGHT_CARE';
export const CDPC_PROGRAM = 'COMPR_PREDIABETES_CARE';
export const ADOL_WM_PROGRAM = 'ADOLESCENT_WEIGHT_MANAGEMENT';
export const RANKED_PROGRAMS = [
    ADOL_WM_PROGRAM,
    'HEART_FAILURE',
    'DIABETES',
    'DIABETES_DEVICEFLEX',
    'PREDIABETES',
    ADPP_PROGRAM,
    CDPC_PROGRAM,
    'HYPERTENSION',
    'CHRONIC_KIDNEY_DISEASE',
    WM_PROGRAM,
    AWM_PROGRAM,
    CWC_PROGRAM,
];
export const ADOLESCENT_AGE_LIMIT = 17;
export const IS_PROD =
    (process.env.ENVIRONMENT ?? window?.process?.env?.ENVIRONMENT) ===
    'production';
export const FEATURE_FLAG_NAMES = {
    enableNewUi: 'enable_new_ui',
    enableAxleForm: 'enable_axle_form',
};
export const MH_MIXPANEL_PRODUCT = 'Mental Health';
export const ENABLE_TRACKING_APPOINTMENT_REQUEST = true;
export {TRACK_EVENT_KEYS} from '../constants/amplitude';
